import script from "./ClaimsBook.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimsBook.vue?vue&type=script&setup=true&lang=js"

import "./ClaimsBook.vue?vue&type=style&index=0&id=2a3120d9&lang=scss"

const __exports__ = script;

export default __exports__